import { isDirectOnlyAdministrator } from '../Utils/NotificationPreferences'

export const shouldReceiveProgramMessage = (user, event, adminMode) => {
  if (!user?._id || user._id === event?.userId) return false

  const isDirectRecipient = event?.toUserIds?.includes(user._id)

  if (isDirectOnlyAdministrator(user, adminMode)) {
    return Boolean(isDirectRecipient)
  }

  return Boolean(
    isDirectRecipient || event?.toRoles?.includes(user?.role)
  )
}
